import React from "react";
import {FormattedMessage} from "react-intl";
import {Api} from "../../../../api/InternalApi";
import {ChooseFileStrategy} from "./ChooseFileStrategy";

export class ChooseLocalOrNetworkFileStrategy implements ChooseFileStrategy {

  constructor(private api: Api) {
  }

  pathSeparator = "\\";

  canInputNewDirectory = true;
  renderNewDirectoryInputLabel = () =>
      <FormattedMessage id="studio.choose-file-form.network-path"
                        defaultMessage="Network Path"/>

  browse(rootPath: string) {
    return this.api.browse(rootPath);
  }
}